"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dates = require("../../consts/dates");

var _BaseIntervalFrequency = _interopRequireDefault(require("../BaseIntervalFrequency"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MonthFrequency = /*#__PURE__*/function (_BaseIntervalFrequenc) {
  _inherits(MonthFrequency, _BaseIntervalFrequenc);

  var _super = _createSuper(MonthFrequency);

  function MonthFrequency() {
    var _this;

    _classCallCheck(this, MonthFrequency);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "repeatOnDictionary", void 0);

    return _this;
  }

  _createClass(MonthFrequency, [{
    key: "addIntervals",
    value: function addIntervals(startDate, operand, day) {
      var every = this.customFrequency.every;
      var newDate = new Date(startDate);
      var nextMonth = startDate.getMonth() + every * operand;
      this.setMonthExact(newDate, nextMonth, day);
      return newDate;
    }
  }, {
    key: "subtractIntervals",
    value: function subtractIntervals(startDate, operand, day) {
      var every = this.customFrequency.every;
      var newDate = new Date(startDate);
      var prevMonth = startDate.getMonth() - every * operand;
      this.setMonthExact(newDate, prevMonth, day);
      return newDate;
    }
  }, {
    key: "getStartOfInterval",
    value: function getStartOfInterval(date) {
      var defaultStartMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var defaultStartDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var _this$customFrequency = this.customFrequency,
          every = _this$customFrequency.every,
          startMonth = _this$customFrequency.startMonth,
          startDay = _this$customFrequency.startDay;
      var month = startMonth != null ? startMonth : defaultStartMonth;
      var day = startDay != null ? startDay : defaultStartDay;
      var start = new Date(date.getTime());
      start.setHours(0, 0, 0, 0);

      if (every === 1) {
        this.setDateOrLastDayOfMonth(start, day);

        if (start > date) {
          return this.subtractIntervals(start, 1, day);
        }

        return start;
      }

      var year = start.getFullYear();

      if (date < new Date(year, month, day)) {
        year -= 1;
      }

      var numSegments = 12 / every;
      var segments = [this.getDateExactMonth(year, month, day)];

      for (var i = 1; i < numSegments; i += 1) {
        var prev = segments[segments.length - 1];
        segments.push(this.getDateExactMonth(prev.getFullYear(), prev.getMonth() + every, day));
      }

      for (var _i = segments.length - 1; _i >= 0; _i -= 1) {
        var curr = segments[_i];

        if (curr && start >= curr) {
          return curr;
        }
      }

      return segments[0];
    }
  }, {
    key: "getWarningDateForUpcomingTasks",
    value: function getWarningDateForUpcomingTasks(baseDate) {
      var every = this.customFrequency.every;
      var advanceNoticeDate = new Date(baseDate.getTime());
      var daysAdvanceNotice = 7;

      if (every === 3) {
        daysAdvanceNotice = 14;
      } else if (every === 6) {
        daysAdvanceNotice = 30;
      }

      advanceNoticeDate.setUTCDate(advanceNoticeDate.getUTCDate() - daysAdvanceNotice);
      return advanceNoticeDate;
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this.isCustom) {
        return 'Custom';
      }

      switch (this.customFrequency.every) {
        case 3:
          return 'Quarterly';

        case 6:
          return this.numberOfEvents() === 2 ? 'Twice Semi-annually' : 'Semi-annually';

        default:
          return this.numberOfEvents() === 2 ? 'Twice Monthly' : 'Monthly';
      }
    }
  }, {
    key: "isIncludedInRepeat",
    value: function isIncludedInRepeat(date) {
      var repeatOn = this.customFrequency.repeatOn;

      if (!repeatOn || !repeatOn.length) {
        return true;
      }

      if (!this.repeatOnDictionary) {
        var repeatOnMonths = repeatOn;
        this.repeatOnDictionary = repeatOnMonths.reduce(function (acc, day) {
          acc[day] = true;
          return acc;
        }, {});
      }

      var dayOfWeek = _dates.MonthOfYear[date.getMonth()];

      return this.repeatOnDictionary[dayOfWeek];
    }
  }]);

  return MonthFrequency;
}(_BaseIntervalFrequency["default"]);

exports["default"] = MonthFrequency;